export const combinationRecommender = `
mutation combinationRecommender($input: RecommenderInput) {
  recommender(input: $input) {
    body
    statusCode
  }
}`

export const validateCustomer = `
mutation validateCustomer($input: ValidateCustomerInput) {
  validateCustomer(input:  $input)
  {
    PostalAddress {
      Address {
        AddressType
        Line1
        Line2
        Line3
        Postcode
        State
        Suburb
      }
    }
    ErrorCode
    Status
  }
}`

export const plateImageGenerator = `
mutation generatePlateImage($input: GeneratePlateImageInput!) {
  generatePlateImage(input: $input)
}`

export const getAddressSuggestions = `
mutation getAddressSuggestions($input: TotalCheckAddressInput) {
  getAddressSuggestions(input: $input)
  {
    AddressList {
      Address
      Moniker
    }
  }
}`

export const getAddressDetails = `
mutation getAddressDetails($input: TotalCheckAddressDetailsInput) {
  getAddressDetails(input: $input)
  {
    Result {
      Dpid
    }
  }
}`

export const createOrder = `
mutation takePaymentAndPlaceOrder($input: TakePaymentAndPlaceOrderInput) {
  takePaymentAndPlaceOrder(input: $input) {
	  Message
	  ExecutionArn
	  StartDate
    OrderNumber
  }
}`

export const purchaseVoucher = `
mutation purchaseVoucher($input: PurchaseVoucherInput!) {
  purchaseVoucher(input: $input) {
	  orderId
	  receiptNumber
	  giftVoucherId
    emailWarning
  }
}`

export const redeemVoucher = `
mutation redeemVoucher($input: RedeemVoucherInput!) {
  redeemVoucher(input: $input) {
	  giftVoucherId
	  applied
	  remainingBalance
    remainderDue
  }
}`


export const plateLock = `
mutation plateLock($input: PlateLockInput) {
  plateLock(input: $input) {
    PlateCombo
    ExpiryTTL
    Status
  }
}`

export const validateCustomerByCardNumber = `
mutation validateCustomerByCardNumber($input: ValidateCustomerByCardNumberInput) {
  validateCustomerByCardNumber(input: $input) {
	  IsVerified
  }
}`

export const subscribeToSwiftMailingList = `
mutation subscribeToSwiftMailingList($input: SwiftSubscribeInput!) {
  subscribeToSwiftMailingList(input: $input) {
    success
    code
    message
  }
}`